// Web Audio API 기반 사운드 효과 시스템
let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioCtx) {
    audioCtx = new AudioContext();
  }
  if (audioCtx.state === "suspended") {
    audioCtx.resume();
  }
  return audioCtx;
}

// 모바일 브라우저를 위한 오디오 초기화 함수
export function initAudio() {
  const ctx = getAudioContext();
  // 더미 사운드를 재생해서 AudioContext 활성화
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  gain.gain.value = 0.001; // 거의 들리지 않게
  osc.connect(gain).connect(ctx.destination);
  osc.start(ctx.currentTime);
  osc.stop(ctx.currentTime + 0.01);
  return ctx;
}

// 범퍼 충돌 사운드 - 밝고 강한 "퐁!" 소리
export function playBumperSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  const osc2 = ctx.createOscillator();
  const gain2 = ctx.createGain();

  osc.type = "sine";
  osc.frequency.setValueAtTime(880, now);
  osc.frequency.exponentialRampToValueAtTime(440, now + 0.15);
  gain.gain.setValueAtTime(0.3, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.2);

  osc2.type = "triangle";
  osc2.frequency.setValueAtTime(1200, now);
  osc2.frequency.exponentialRampToValueAtTime(300, now + 0.1);
  gain2.gain.setValueAtTime(0.15, now);
  gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.15);

  osc.connect(gain).connect(ctx.destination);
  osc2.connect(gain2).connect(ctx.destination);

  osc.start(now);
  osc.stop(now + 0.2);
  osc2.start(now);
  osc2.stop(now + 0.15);
}

// 핀(페그) 충돌 사운드 - 가벼운 "틱" 소리
export function playPegSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = "sine";
  const freq = 1800 + Math.random() * 600;
  osc.frequency.setValueAtTime(freq, now);
  osc.frequency.exponentialRampToValueAtTime(freq * 0.5, now + 0.06);
  gain.gain.setValueAtTime(0.12, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.08);

  osc.connect(gain).connect(ctx.destination);
  osc.start(now);
  osc.stop(now + 0.08);
}

// 디플렉터 충돌 사운드 - 중간 톤 "탕" 소리
export function playDeflectorSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = "square";
  osc.frequency.setValueAtTime(600, now);
  osc.frequency.exponentialRampToValueAtTime(200, now + 0.12);
  gain.gain.setValueAtTime(0.1, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.15);

  osc.connect(gain).connect(ctx.destination);
  osc.start(now);
  osc.stop(now + 0.15);
}

// 벽 충돌 사운드 - 둔탁한 "퉁" 소리
export function playWallSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = "sine";
  osc.frequency.setValueAtTime(200, now);
  osc.frequency.exponentialRampToValueAtTime(80, now + 0.1);
  gain.gain.setValueAtTime(0.08, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.12);

  osc.connect(gain).connect(ctx.destination);
  osc.start(now);
  osc.stop(now + 0.12);
}

// 발사 사운드 - "슈웅!" 소리
export function playLaunchSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  const noise = ctx.createOscillator();
  const noiseGain = ctx.createGain();

  osc.type = "sawtooth";
  osc.frequency.setValueAtTime(150, now);
  osc.frequency.exponentialRampToValueAtTime(1200, now + 0.15);
  osc.frequency.exponentialRampToValueAtTime(400, now + 0.3);
  gain.gain.setValueAtTime(0.15, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.35);

  noise.type = "sawtooth";
  noise.frequency.setValueAtTime(80, now);
  noise.frequency.exponentialRampToValueAtTime(2000, now + 0.1);
  noiseGain.gain.setValueAtTime(0.06, now);
  noiseGain.gain.exponentialRampToValueAtTime(0.001, now + 0.2);

  osc.connect(gain).connect(ctx.destination);
  noise.connect(noiseGain).connect(ctx.destination);

  osc.start(now);
  osc.stop(now + 0.35);
  noise.start(now);
  noise.stop(now + 0.2);
}

// 바구니 착지 사운드 - 성공적인 "딩!" 소리
export function playBasketSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc1 = ctx.createOscillator();
  const gain1 = ctx.createGain();
  const osc2 = ctx.createOscillator();
  const gain2 = ctx.createGain();

  osc1.type = "sine";
  osc1.frequency.setValueAtTime(523, now);
  gain1.gain.setValueAtTime(0.25, now);
  gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.4);

  osc2.type = "sine";
  osc2.frequency.setValueAtTime(784, now + 0.08);
  gain2.gain.setValueAtTime(0.001, now);
  gain2.gain.setValueAtTime(0.2, now + 0.08);
  gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.5);

  osc1.connect(gain1).connect(ctx.destination);
  osc2.connect(gain2).connect(ctx.destination);

  osc1.start(now);
  osc1.stop(now + 0.4);
  osc2.start(now + 0.08);
  osc2.stop(now + 0.5);
}

// 중복 번호 튕김 사운드 - "삐빅" 경고음
export function playRejectSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = "square";
  osc.frequency.setValueAtTime(300, now);
  osc.frequency.setValueAtTime(250, now + 0.1);
  gain.gain.setValueAtTime(0.12, now);
  gain.gain.setValueAtTime(0.12, now + 0.08);
  gain.gain.setValueAtTime(0.001, now + 0.1);
  gain.gain.setValueAtTime(0.12, now + 0.12);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.25);

  osc.connect(gain).connect(ctx.destination);
  osc.start(now);
  osc.stop(now + 0.25);
}

// 게임 완료 팡파레 사운드
export function playCompleteSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const notes = [523, 659, 784, 1047];
  notes.forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const startTime = now + i * 0.12;

    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, startTime);
    gain.gain.setValueAtTime(0.001, now);
    gain.gain.setValueAtTime(0.2, startTime);
    gain.gain.exponentialRampToValueAtTime(0.001, startTime + 0.5);

    osc.connect(gain).connect(ctx.destination);
    osc.start(startTime);
    osc.stop(startTime + 0.5);
  });
}

// 킥커 충돌 사운드 - 강한 "퍽!" 소리
export function playKickerSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  const osc2 = ctx.createOscillator();
  const gain2 = ctx.createGain();

  osc.type = "sawtooth";
  osc.frequency.setValueAtTime(400, now);
  osc.frequency.exponentialRampToValueAtTime(100, now + 0.15);
  gain.gain.setValueAtTime(0.25, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.2);

  osc2.type = "square";
  osc2.frequency.setValueAtTime(200, now);
  osc2.frequency.exponentialRampToValueAtTime(60, now + 0.1);
  gain2.gain.setValueAtTime(0.18, now);
  gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.12);

  osc.connect(gain).connect(ctx.destination);
  osc2.connect(gain2).connect(ctx.destination);

  osc.start(now);
  osc.stop(now + 0.2);
  osc2.start(now);
  osc2.stop(now + 0.12);
}

// 스핀너 충돌 사운드 - 회전하는 "위잉~" 소리
export function playSpinnerSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = "sine";
  osc.frequency.setValueAtTime(600, now);
  osc.frequency.linearRampToValueAtTime(1400, now + 0.15);
  osc.frequency.linearRampToValueAtTime(800, now + 0.3);
  gain.gain.setValueAtTime(0.15, now);
  gain.gain.setValueAtTime(0.18, now + 0.1);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.35);

  osc.connect(gain).connect(ctx.destination);
  osc.start(now);
  osc.stop(now + 0.35);
}

// 인트로 시그널 사운드 - "삐리리릭~" 게임 시작 신호음
export function playIntroSignalSound() {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  // 1단계: 짧은 상승 비프 x3
  const beepFreqs = [440, 660, 880];
  beepFreqs.forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const t = now + i * 0.13;

    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, t);
    osc.frequency.exponentialRampToValueAtTime(freq * 1.3, t + 0.09);
    gain.gain.setValueAtTime(0.001, t);
    gain.gain.linearRampToValueAtTime(0.18, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.1);

    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.12);
  });

  // 2단계: 길고 화려한 상승 스윕
  const sweep = ctx.createOscillator();
  const sweepGain = ctx.createGain();
  const sweepStart = now + 0.42;

  sweep.type = "sawtooth";
  sweep.frequency.setValueAtTime(300, sweepStart);
  sweep.frequency.exponentialRampToValueAtTime(1800, sweepStart + 0.35);
  sweepGain.gain.setValueAtTime(0.001, sweepStart);
  sweepGain.gain.linearRampToValueAtTime(0.14, sweepStart + 0.05);
  sweepGain.gain.exponentialRampToValueAtTime(0.001, sweepStart + 0.38);

  sweep.connect(sweepGain).connect(ctx.destination);
  sweep.start(sweepStart);
  sweep.stop(sweepStart + 0.4);

  // 3단계: 마무리 화음 (도-미-솔)
  const chordFreqs = [523, 659, 784];
  chordFreqs.forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const t = now + 0.82 + i * 0.07;

    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, t);
    gain.gain.setValueAtTime(0.001, t);
    gain.gain.linearRampToValueAtTime(0.16, t + 0.04);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.45);

    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.5);
  });
}
